"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _moment = _interopRequireDefault(require("moment"));
var _reactFontawesome = _interopRequireDefault(require("react-fontawesome"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var TopHands = /*#__PURE__*/function (_React$Component) {
  _inherits(TopHands, _React$Component);
  var _super = _createSuper(TopHands);
  function TopHands(props) {
    var _this;
    _classCallCheck(this, TopHands);
    _this = _super.call(this, props);
    _this.getPromotionalContent = function () {
      _this.setState({
        loading: true
      });
      // apiService(baseUrl + '/reportCard/getPromotionalContent', {
      //   "score": this.props.playerReports.summaryInfo[0].points
      // }, (data) => {
      //   this.setState({ promotionTitle: data[0].title })
      //   this.setState({ promotionUrl: data[0].imageLink })
      //   this.setState({ content: data[0].content })
      //   this.setState({ webLink: data[0].webLink })
      //   this.forceUpdate()
      // }, (data) => {
      //   if (data.status == 403) {
      //     this.setState({ loginRedirect: true })
      //   }
      //   this.setState({ loading: false })
      // })
    };
    _this.showOrHideHands = function (handListType) {
      if (_this.state["".concat(handListType, "ShowMore")] === false) {
        var data = {},
          activityTrack = [],
          track = {
            hit_timestamp: (0, _moment["default"])().format(),
            session_id: localStorage.getItem("token"),
            userid: localStorage.getItem("username"),
            deviceInfo: JSON.parse(localStorage.getItem("deviceInfo")),
            hit_page: "ReportCard",
            hit_type: handListType === "won" ? "ReportCardWinningShowMore" : "ReportCardLosingShowMore",
            hit_attribute1: "",
            hit_attribute2: "",
            hit_attribute3: "",
            hit_attribute4: "",
            hit_attribute5: ""
          };
        data["".concat(handListType, "ShowMore")] = true;
        if (localStorage.getItem("activityTrack")) activityTrack = JSON.parse(localStorage.getItem("activityTrack"));
        activityTrack.push(track);
        localStorage.setItem("activityTrack", JSON.stringify(activityTrack));
        _this.setState(data);
      } else {
        var _data = {};
        _data["".concat(handListType, "ShowMore")] = false;
        _this.setState(_data);
        setTimeout(function () {
          _this.setState(_data);
        }, 250);
      }
    };
    _this.state = {
      wonShowMore: false,
      lostShowMore: false,
      openHandRep: false,
      promotionTitle: "",
      promotionUrl: "",
      webLink: "",
      content: "",
      loading: true,
      playFlag: true,
      gameNo: "",
      partitionDate: "",
      repoSetting: {},
      potsLoading: false
    };
    return _this;
  }
  // componentDidMount = () => {
  //     this.getPromotionalContent()
  // }

  // componentWillReceiveProps = (nextProps) => {
  //     let repoSetting = { ...this.props.reportCardSetting.filter(eachGameReportSetting => eachGameReportSetting.gameType === this.props.gameType)[0] }
  //     let getPromotionalData = _.isEqual(this.state.reportSetting, repoSetting)
  //     if (!getPromotionalData) {
  //         this.setState({ reportSetting: repoSetting })
  //         this.getPromotionalContent()
  //     }
  // }
  _createClass(TopHands, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "grid  pot".concat(this.props.handListType === 'lost' ? 'Loss' : 'Win', "Alignment")
      }, /*#__PURE__*/_react["default"].createElement("h3", {
        className: "biggestPotsCss"
      }, "Biggest Pots ", this.props.handListType), /*#__PURE__*/_react["default"].createElement("span", {
        "data-e2e": "potsLoss"
      }, this.props.hands && this.props.hands.length > 0 ? this.props.hands.map(function (item, index) {
        if (_this2.state["".concat(_this2.props.handListType, "ShowMore")] == false) {
          if (index > 2) return;
        }
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: index,
          className: "grid handDetailsRow",
          style: {
            borderBottom: "1px solid #B7B7B7",
            gridTemplateColumns: "1fr 1fr 1fr",
            gridColumnGap: "6px"
          }
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: "handCardImages"
        }, _this2.props.isLiveview !== true && item.cardUrl.length == 2 ? /*#__PURE__*/_react["default"].createElement("div", null) : null, item.cardUrl.map(function (card, index) {
          return /*#__PURE__*/_react["default"].createElement("img", {
            key: index,
            "data-e2e": "cardImgPotLoss",
            src: card,
            style: {
              border: "1px solid dimgray"
            }
          });
        })), /*#__PURE__*/_react["default"].createElement("span", {
          className: "liveReport_profitLoss",
          style: {
            alignSelf: "center",
            color: "".concat(_this2.props.handListType === 'lost' ? "#FF4E3E" : "#7ED321"),
            fontFamily: "Roboto",
            fontSize: "14px",
            fontWeight: "bold",
            letterSpacing: "0.04px",
            lineHeight: "19px"
          }
        }, item.profit < 0 ? "- " : "", _this2.props.gameType != "tournament" && "$", "\xA0", Math.abs(item.profit.toFixed(2)), "\xA0", _this2.props.gameType === "tournament" && "BB"), /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("button", {
          "data-e2e": "lossReplay",
          onClick: function onClick(e) {
            e.preventDefault();
            _this2.props.handReplayerOpen(item, _this2.props.handListType);
          },
          className: "mg-btn saffron greyBtnLiveReport btnHalo",
          style: {
            margin: "10% 0%",
            height: "30px",
            width: "60px",
            padding: "6px 0px",
            justifySelf: "end"
          }
        }, "REPLAY")));
      }) : /*#__PURE__*/_react["default"].createElement("h5", null, "No Hands Data Found")), this.props.hands && this.props.hands.length > 0 && /*#__PURE__*/_react["default"].createElement("span", null, this.state["".concat(this.props.handListType, "ShowMore")] == false ? /*#__PURE__*/_react["default"].createElement("h5", {
        "data-e2e": "potsLossShowMore",
        className: "showMoreOrLessTopHands",
        onClick: function onClick() {
          return _this2.showOrHideHands(_this2.props.handListType);
        }
      }, "Show More\xA0\xA0", /*#__PURE__*/_react["default"].createElement("i", {
        className: "fa fa-chevron-down"
      })) : /*#__PURE__*/_react["default"].createElement("h5", {
        className: "showMoreOrLessTopHands",
        onClick: function onClick() {
          return _this2.showOrHideHands(_this2.props.handListType);
        }
      }, "Show Less\xA0\xA0", /*#__PURE__*/_react["default"].createElement("i", {
        className: "fa fa-chevron-up"
      }))));
    }
  }]);
  return TopHands;
}(_react["default"].Component);
var _default = TopHands;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/TopHands.js
 ** module id = 2403
 ** module chunks = 0
 **/